import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage'; // Import Login
import ConfirmationPage from './pages/ConfirmationPage';

// This wrapper checks if the user is authenticated
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  const isAuthenticated = token === 'aura-access-granted-2026';
  
  return isAuthenticated ? children : <Navigate to="/admin-login" />;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/confirmation" element={<ConfirmationPage />} />
      <Route path="/admin-login" element={<LoginPage />} />
      
      {/* Access this only if logged in */}
      <Route 
        path="/admin-aura" 
        element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}

export default App;